var createStyled = {};

export { createStyled as __exports };
